import { Rating, Tooltip } from '@pinpointhq/thumbtack';
import * as React from 'react';

export interface IRatingCellProps {
  rating: number;
}

export function RatingCell({ rating }: IRatingCellProps) {
  return (
    <Tooltip content={rating ? `Rating: ${rating}` : 'Not rated'}>
      <Rating rating={Math.round(rating * 2) / 2} />
    </Tooltip>
  );
}
